module.exports = __webpack_public_path__ + "img/img16.10d7edfc.png";